import React, { memo } from "react";
import { useRecoilState } from "recoil";
import { snackbarAtom } from "../../selectorsAtoms";
import { components } from "@workspace/shared";

const { Snackbar } = components;

const SnackbarWrapper = () => {
  const [value, setValue] = useRecoilState(snackbarAtom);
  return <Snackbar value={value} setValue={setValue} />;
};

export default memo(SnackbarWrapper);
